<template>
  <div class="fangancalc">
    <sub-title text="实用计算器" />
    <ul>
      <li class="flex_start">
        <div><img src="../../../assets/jpcol/syjsq_ss.png" alt="" /></div>
        <div>诉讼费计算器</div>
      </li>

      <li class="flex_start">
        <div><img src="../../../assets/jpcol/syjsq_gs.png" alt="" /></div>
        <div>工伤赔偿计算器</div>
      </li>

      <li class="flex_start">
        <div><img src="../../../assets/jpcol/syjsq_jt.png" alt="" /></div>
        <div>交通赔偿计算器</div>
      </li>
    </ul>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";

export default {
  components: {
    subTitle,
  },
};
</script>

<style lang="scss" scoped>
.fangancalc {
  width: 100%;
  height: 100%;
  padding: 24px 20px;
  ul {
    padding: 0 8px;
    li {
      margin-top: 24px;
      font-size: 16px;
      color: #666666;
      cursor: pointer;
      &:hover {
        color: #0465ea;
      }
      img {
        margin-right: 14px;
      }
    }
  }
}
</style>